import * as Yup from 'yup'
import {ShortTitle} from 'Validations'

const Validation = Yup.object({
  projectName: ShortTitle
})

export default Validation
